/** Coalesces concurrent drop-out requests into one run. */
export class PreSpinDropOutGate {
  private running: Promise<void> | null = null;

  public constructor(private readonly dropOut: () => Promise<void>) {}

  /** Starts the drop-out if none is running; returns the shared promise. */
  public request(): Promise<void> {
    if (this.running) return this.running;
    this.running = (async () => {
      try {
        await this.dropOut();
      } finally {
        this.running = null;
      }
    })();
    return this.running;
  }

  public isRunning(): boolean {
    return this.running !== null;
  }
}
